import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '10px 20px 30px 20px',
    minHeight: 'calc(100vh - 100px)',
    maxHeight: 'calc(100vh - 100px)',
    height: 'calc(100vh - 100px)',
    width: '100%',
    background: 'rgba(92, 107, 192, 0.2) !important',
  },

  homeText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    fontSize: '24px !important',
    fontWeight: 'bold',
    color: `${theme.palette.primary.contrastText} !important`,
  },

  logo: {
    height: '70px',
  },
}))

export { useStyles }
